import type { SectionId } from "@/config/uiConfig";

export type RouteAccess = "loading" | "login" | "forbidden" | "allowed";

export function resolveRouteAccess({
  isLoading,
  isAuthenticated,
  sectionId,
  canAccessSection,
}: {
  isLoading: boolean;
  isAuthenticated: boolean;
  sectionId?: SectionId;
  canAccessSection: (sectionId: SectionId) => boolean;
}): RouteAccess {
  if (isLoading) return "loading";
  if (!isAuthenticated) return "login";
  if (sectionId && !canAccessSection(sectionId)) return "forbidden";

  return "allowed";
}
